export default "__VITE_ASSET__0c09415d__"